export default __webpack_public_path__ + "static/media/BCTransport.d2aa5cd1.png";